import React, { FunctionComponent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { View } from 'react-native'
import styled from 'styled-components'
import nativeStyled from 'styled-components/native'

import { faUserPlus } from '@fortawesome/pro-light-svg-icons'

import { FaIcon } from '../../../App/Components'
import { IAppState } from '../../../store/IAppState'
import StyleVariables from '../../../StyleVariables'
import { IProps } from './IProps'
import { WarningModal } from '../../../App/Components/WarningModal/WarningModal'

/**
 * OB-499: Native <button>. Was styled(TouchableOpacity).
 */
const ButtonContainer = styled.button<{ color: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 8px ${StyleVariables.horizontalGutter};
  border: 1px solid ${({ color }) => color};
  border-radius: ${StyleVariables.borderRadiusPill};
  margin: 16px 20px 32px;
  align-self: center;
  max-width: ${StyleVariables.cardMaxWidth};
  width: fit-content;
  background: transparent;
  appearance: none;
  cursor: pointer;
  font: inherit;
`

const ButtonText = nativeStyled.Text<{ color: string }>`
  font-size: ${StyleVariables.fontSizeBase};
  color: ${({ color }) => color};
  margin-left: 10px;
`

export const AddCustomerButton: FunctionComponent<IProps> = ({
  isMultipleCustomer,
}) => {
  const [isWarningOpen, setIsWarningOpen] = useState(false)
  const { t } = useTranslation()

  const settings = useSelector((state: IAppState) => state.settings.values)

  const openWarningModal = () => {
    setIsWarningOpen(true)
    setTimeout(() => setIsWarningOpen(false), 500)
  }

  if (!isMultipleCustomer) {
    return null
  }

  const { highlightColor } = settings

  return (
    <View>
      <WarningModal
        description="By clicking on 'Add Person' you will add a additional person to this appointment. If you wish to cancel this, click the cross icon."
        title="Add a other person"
        isModalOpen={isWarningOpen}
      />
      <ButtonContainer
        type="button"
        color={highlightColor}
        onClick={openWarningModal}
        data-component="add-customer-button"
      >
        <FaIcon size="lg" icon={faUserPlus} color={highlightColor} />
        <ButtonText color={highlightColor}>{t('Add extra person')}</ButtonText>
      </ButtonContainer>
    </View>
  )
}
